import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { visitContentQuerySchema } from "./visit-content";

const deviceId = z
  .string()
  .min(1)
  .refine(
    (value) => Array.from(value).length <= 255,
    "Device ID exceeds 255 characters",
  );
export const ownDevicesQuerySchema = z.strictObject({
  limit: visitContentQuerySchema.shape.limit,
  cursor: deviceId.optional(),
});
export type OwnDevicesQuery = z.output<typeof ownDevicesQuerySchema>;
export const ownDevicesSchema = z.object({
  items: z.array(z.object({ id: deviceId, deviceName: z.string() })),
  nextCursor: deviceId.nullable(),
});
export const deviceReadContract = {
  ownDevices: oc
    .errors({
      BAD_REQUEST: { message: "Invalid request" },
      NOT_FOUND: { message: "Not Found" },
      METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
      INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
    })
    .input(
      z.object({
        query: ownDevicesQuerySchema.default({ limit: 50 }),
        body: z.undefined().optional(),
      }),
    )
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/me/devices",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(ownDevicesSchema),
};
